import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  ActiveInactiveCertificate,
  createCertificate,
  deleteCertificate,
  getAllActiveCertificate,
  getAllCertificate,
  getCertificateByID,
  updateCertificate,
} from "./services/certificate.services";

export interface ICertificateState {
  loading: boolean;
  formloading: boolean;
  error: string;
  CertificateID: number | null;
  CertificateList: ICertificate[];
  CertificateDetail: ICertificateDetails;
}

export interface ICertificateDetails {
  ID?: number | null;
  Certificate: string;
  IsActive: number | boolean;
}
export interface ICertificate {
  Name: string;
  Image: string;
  IsActive: number | boolean;
}

const initialState: ICertificateState = {
  loading: false,
  formloading: false,
  error: "",
  CertificateID: null,
  CertificateList: [],
  CertificateDetail: {
    Certificate: "",
    IsActive: 1,
  },
};

const certificateSlice = createSlice({
  name: "certificate",
  initialState,
  reducers: {
    clearCertificateDetails: (state) => {
      state.CertificateDetail = initialState.CertificateDetail;
    },
    setCertificateID: (state, action) => {
      state.CertificateID = action.payload;
    },
    clearCertificateID: (state) => {
      state.CertificateID = initialState.CertificateID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCertificate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCertificate.fulfilled,
      (state, action: PayloadAction<ICertificate[]>) => {
        state.loading = false;
        state.CertificateList = action.payload || [];
      }
    );
    builder.addCase(getAllCertificate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CertificateList = [];
    });
    builder.addCase(createCertificate.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createCertificate.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createCertificate.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCertificate.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateCertificate.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateCertificate.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCertificate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCertificate.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCertificate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCertificateByID.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(getCertificateByID.fulfilled, (state, action: any) => {
      state.formloading = false;
      state.CertificateDetail = action.payload;
    });
    builder.addCase(getCertificateByID.rejected, (state, action) => {
      state.formloading = false;
      state.CertificateDetail = initialState.CertificateDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCertificate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCertificate.fulfilled,
      (state, action: PayloadAction<ICertificate[]>) => {
        state.loading = false;
        state.CertificateList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCertificate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CertificateList = [];
    });
    builder.addCase(ActiveInactiveCertificate.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveCertificate.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveCertificate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCertificateDetails, clearCertificateID, setCertificateID } = certificateSlice.actions;
export default certificateSlice.reducer;
